import { Playable2DRootContainer } from './core/Playable2DRootContainer';
import { PlayableLevel } from './game';
import gsap from 'gsap';
import { initLanguage } from './translate';
import { theme } from './theme';
import { GamePlaceholder } from 'components/GamePlaceholder';
import { Layout } from './LayoutManager';
import { initializeUI } from 'ui';

import { loadMainAssets, isSupportWebP, preLoadGameAssets } from './preloadGameAssets';

import { GamePreloader } from './GamePreloader';
import { Store } from './store/gameStore';
import { getDifficultyDeals, getRandomDifficultyId } from './deals';
import { BackgroundLevel } from 'components/gameBackground';
import { GameEvent } from './events/gameEvent';
import { EventName } from './events/eventsName';
import { difficultyLevelData, DifficultyLevelType, GameName } from 'constants/difficulty';
import { GAEvent, GAEventNames } from './analytics/events';
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { getStrategyByGame } from './utils/strategy';


gsap.registerPlugin(MotionPathPlugin);

export const gameContainerId = 'solitaire-container';
if (document.readyState === 'complete') {
    initGame();
} else {
    window.onload = initGame;
}

function initGame() {

    isSupportWebP(async () => {
        await initLanguage();

        new Playable2DRootContainer({ backgroundColor: theme.gameBackground });

        getStrategyByGame(Store.name);
        Layout.setLayout();
        new GamePlaceholder();
        let assetsLoaded = false;
        const preloader = new GamePreloader();
        getDifficultyDeals(Store.difficulty).then(async () => {
            //fetch deal id
            let lastGameId = Store.getPreviousGameId(Store.difficulty);
            if (!lastGameId) {
                const difficultyForGameType = [] as DifficultyLevelType[];
                Object.keys(difficultyLevelData).forEach((key) => {
                    switch (Store.name) {
                        case GameName.KLONDIKE:
                            if (key.includes('KLONDIKE')) {
                                if (key.includes('_' + Store.getDealCount()))
                                    difficultyForGameType.push(key as DifficultyLevelType);
                            }
                            break;
                        case GameName.SPIDER:
                            if (key.includes('SPIDER')) {
                                if (key.includes('_' + Store.suits))
                                    difficultyForGameType.push(key as DifficultyLevelType);
                            }
                            break;

                        case GameName.FREECELL:
                            if (key.includes('FREECELL')) {
                                difficultyForGameType.push(key as DifficultyLevelType);
                            }
                            break;
                        case GameName.PYRAMID:
                            if (key.includes('PYRAMID')) {
                                difficultyForGameType.push(key as DifficultyLevelType);
                            }
                            break;
                    }
                });
                const randomIndex = Math.floor(Math.random() * (difficultyForGameType.length + 1));
                if (randomIndex >= difficultyForGameType.length || Store.difficultyStarted.length) {
                    Store.setDifficulty(difficultyForGameType[0], true);
                } else {
                    const difficulty = difficultyForGameType[randomIndex];
                    Store.setDifficulty(difficulty, false);
                }

                lastGameId = await getRandomDifficultyId(Store.difficulty);
                if (!Store.difficultyStarted.length) {
                    GAEvent(GAEventNames.DIFFICULTY_SET_UP, {
                        difficulty: Store.getDifficultyText(),
                        type: Store.getGameTypeText(),
                    });
                }
            }
            if (lastGameId) {
                Store.gameId = lastGameId;
            }

            preLoadGameAssets(() => {
                preloader.init();
                initializeUI();

                GameEvent.emit(EventName.SHOW_LOADER);
                new BackgroundLevel();

                loadMainAssets(() => {
                    assetsLoaded = true;
                    GameEvent.emit(EventName.HIDE_LOADER);

                    if (assetsLoaded) {
                        onLoad();
                    }
                });
            });
        });
    });
}

function onLoad() {
    new PlayableLevel();

    const canvases = document.getElementsByName('canvas');
    canvases.forEach((c) => {
        c.ontouchstart = (e) => {
            e.preventDefault();
            e.stopPropagation();
        };
    });
    const gameContainer = document.getElementById(gameContainerId);
    if (gameContainer)
        gameContainer.oncontextmenu = function (event) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        };
}
